import { languages } from './configuration';

export default { languages };
